import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

Splide.defaults = {
  type: 'loop',
  perPage: 3,
  perMove: 1,
  gap: '1rem',
  pagination: false,
}

jQuery(function($){

  const sliders = document.querySelectorAll('.splide');

  sliders.forEach(slider => {
    if (slider.classList.contains('marquee')) {
      new Splide(slider, {
        drag: 'free',
        focus: 'center',
        perPage: null,
        autoWidth: true,
        autoScroll: {
          speed: 1,
        },
        // breakpoints: {
        //   '1350': {
        //     perPage: 3,
        //   },
        //   '720': {
        //     perPage: 1,
        //   },
        // },
      }).mount({ AutoScroll });
    } else {
      new Splide(slider).mount();
    }
  });

});
